import { templateThemeTokens } from './templateThemeTokens.js';
import { THEME_DEFAULT_FONTS } from '@/contexts/CustomThemeConfigContext/constants.js';
import { createTheme } from '@/stitches/index.js';

export const morning = createTheme({
  ...templateThemeTokens,
  colors: {
    defaultFont: '#DC4C2D',
    pageBackground: '#F4F0EB',
  },
  fonts: {
    accent: THEME_DEFAULT_FONTS.losAngeles.morning.accent
      ? THEME_DEFAULT_FONTS.losAngeles.morning.accent.value
      : 'unset',
    body: THEME_DEFAULT_FONTS.losAngeles.morning.body.value,
    heading: THEME_DEFAULT_FONTS.losAngeles.morning.headline.value,
  },
});
